import Vue from "vue";
import MagnakataContactForm from './components/MagnakataContactForm';

const contactForm = new Vue({
    el: '#contact-form',
    components: {
        MagnakataContactForm
    }
})